import {AddGradeActions} from ".";

let initialState = {
    saveGradeInformationInProgress:false,
    gradeList:{},
    gradesList:[],
    getGradesInProgress:false,
    getGradeMasterDataInProgress:false
}

export const addGradeReducer = (state = initialState  , action ) =>{
    switch(action.type){
        case AddGradeActions.ADD_GRADE_IN_PROGRESS:
            return{...state , saveGradeInformationInProgress:true};
        case AddGradeActions.ADD_GRADE_COMPLETE:
            return{...state , saveGradeInformationInProgress:false ,data:action.data}

            
        case AddGradeActions.GET_GRADE_MASTER_DATA_IN_PROGRESS :
            return {...state , getGradeMasterDataInProgress:true};

        case AddGradeActions.GET_GRADE_MASTER_DATA_COMPLETE :
            return{...state , getGradeMasterDataComplete:false , gradeList:action.data};

        case AddGradeActions.GET_GRADES_IN_PROGRESS :
            return {...state , getGradesInProgress:true};

        case AddGradeActions.GET_GRADES_COMPLETE :
            return{...state , getGradesInProgress:false , gradesList:action.data};

        default :
        return state
    }
}
  
export default addGradeReducer;